module.exports = __webpack_public_path__ + "static/img/astrology-metaverse-home-hover.d26465c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/astrology/astrology-metaverse-home-hover.png
// module id = BMxf
// module chunks = 0